/*
 *
 *  Vuetify Colors
 */

// gray
export const gray = {
  lighten5: '#f7fafc',
  lighten4: '#edf2f7',
  lighten3: '#e2e8f0',
  lighten2: '#cbd5e0',
  lighten1: '#a0aec0',
  base: '#718096',
  darken1: '#4a5568',
  darken2: '#2d3748',
  darken3: '#171c26', // 1a202c
  darken4: '#0c1017', // 0c1322 - 0c111d
  darken5: '#070b12' // 040a15
}

// indigo
export const indigo = {
  lighten5: '#EBF4FF',
  lighten4: '#C3DAFE',
  lighten3: '#A3BFFA',
  lighten2: '#7F9CF5',
  lighten1: '#667EEA',
  base: '#5A67D8',
  darken1: '#4C51BF',
  darken2: '#434190',
  darken3: '#3C366B',
  darken4: '#3C366B'
}

// red
export const red = {
  lighten5: '#fff5f5',
  lighten4: '#fed7d7',
  lighten3: '#feb2b2',
  lighten2: '#fc8181',
  lighten1: '#f56565',
  base: '#e53e3e',
  darken1: '#c53030',
  darken2: '#9b2c2c',
  darken3: '#742a2a',
  darken4: '#742a2a'
}

// orange
export const orange = {
  lighten5: '#FFFAF0',
  lighten4: '#FEEBC8',
  lighten3: '#FBD38D',
  lighten2: '#F6AD55',
  lighten1: '#ED8936',
  base: '#DD6B20',
  darken1: '#C05621',
  darken2: '#9C4221',
  darken3: '#7B341E',
  darken4: '#7B341E'
}

// green
export const green = {
  lighten5: '#F0FFF4',
  lighten4: '#C6F6D5',
  lighten3: '#9AE6B4',
  lighten2: '#68D391',
  lighten1: '#48BB78',
  base: '#38A169',
  darken1: '#2F855A',
  darken2: '#276749',
  darken3: '#22543D',
  darken4: '#22543D'
}
// teal
export const teal = {
  lighten5: '#E6FFFA',
  lighten4: '#B2F5EA',
  lighten3: '#81E6D9',
  lighten2: '#4FD1C5',
  lighten1: '#38B2AC',
  base: '#319795',
  darken1: '#2C7A7B',
  darken2: '#285E61',
  darken3: '#234E52',
  darken4: '#234E52'
}

// red
export const blue = {
  lighten5: '#EBF8FF',
  lighten4: '#BEE3F8',
  lighten3: '#90CDF4',
  lighten2: '#63B3ED',
  lighten1: '#4299E1',
  base: '#3182CE',
  darken1: '#2B6CB0',
  darken2: '#2C5282',
  darken3: '#2A4365',
  darken4: '#2A4365'
}

// purple
export const purple = {
  lighten5: '#FAF5FF',
  lighten4: '#E9D8FD',
  lighten3: '#D6BCFA',
  lighten2: '#B794F4',
  lighten1: '#9F7AEA',
  base: '#805AD5',
  darken1: '#6B46C1',
  darken2: '#553C9A',
  darken3: '#44337A',
  darken4: '#44337A'
}

// pink
export const pink = {
  lighten5: '#FFF5F7',
  lighten4: '#FED7E2',
  lighten3: '#FBB6CE',
  lighten2: '#F687B3',
  lighten1: '#ED64A6',
  base: '#D53F8C',
  darken1: '#B83280',
  darken2: '#97266D',
  darken3: '#702459',
  darken4: '#702459'
}

// yellow
export const yellow = {
  lighten5: '#FFFFF0',
  lighten4: '#FEFCBF',
  lighten3: '#FAF089',
  lighten2: '#F6E05E',
  lighten1: '#ECC94B',
  base: '#D69E2E',
  darken1: '#B7791F',
  darken2: '#975A16',
  darken3: '#744210',
  darken4: '#744210'
}

// primary colors
export const primaryColors = {
  red,
  orange,
  yellow,
  green,
  teal,
  blue,
  indigo,
  purple,
  pink
}

// default export
export default {
  gray,
  red,
  orange,
  yellow,
  green,
  teal,
  blue,
  indigo,
  purple,
  pink
}
